<template>
  <div>
    <Form
      ref="formValidate"
      :model="formValidate"
      :rules="ruleValidate"
      :label-width="80"
    >
      <FormItem label="订单编号">
        <Input v-model="formValidate.orderNo" disabled></Input>
      </FormItem>
      <FormItem label="缸号" v-if="formValidate.type==0">
        <Select
          v-model="formValidate.batchId"
          @on-change="searchPiece"
          filterable
        >
          <Option v-for="item in batchList" :value="item.id" :key="item.id">{{
            item.batch_no
          }}</Option>
        </Select>
      </FormItem>
      <FormItem label="布匹" v-if="formValidate.type==0">
        <tables
          ref="tables"
          editable
          :columns="columns"
          v-model="tableData"
          :loading="tableLoading"
          @on-selection-change="selectData"
        />
      </FormItem>
      <FormItem label="出货匹数" v-if="formValidate.type==1">
        <p>可出货匹数: <b style="font-size:16px;">{{ all_piece - used_count - formValidate.count }}</b></p>
        <Button @click="addPiece">增加</Button>
        <label style="margin: auto 10px;">出货匹数: {{ formValidate.count }}</label>
        <Button @click="cutPiece">减少</Button>
        <p></p>
        <Input type="number" v-model="exportCount" style="margin-top: 5px; width: 200px;" :min="0" placeholder="输入出货匹数"></Input>
        <Button @click="calPiece" style="margin-top: 5px; margin-left: 5px;">计算</Button>
        <!-- <Input @on-change="sumup" @on-blur="sumup" v-model="formValidate.count" type="number"></Input> -->
      </FormItem>
      <FormItem style="text-align: right">
        <!-- <Button @click="handleReset('formValidate')">重置</Button> -->
        <Button
          type="primary"
          @click="handleSubmit('formValidate')"
          style="margin-left: 8px"
          >提交</Button
        >
      </FormItem>
    </Form>
  </div>
</template>

<script>
import params from "../argu-page/params.vue";
import Tables from "_c/tables/table-only.vue";
// import * as math from 'mathjs';
import { searchBatch, searchPiece, addPieceShipment } from "@/api/data";
export default {
  components: { params, Tables },
  props: {
    resetFlag: {
      type: Boolean,
      default: false,
    },
    editData: {
      type: Object,
      default: () => {},
    },
    edit: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      batchList: [],
      tableLoading: false,
      tableData: [],
      columns: [
        {
          type: "selection",
          width: 60,
          align: "center",
          fixed: "left",
        },
        { title: "匹号", key: "piece_no", editable: true },
        { title: "客户匹号", key: "customer_piece_no", editable: true },
        { title: "要求码长", key: "stand_length_code", editable: true },
        { title: "机测码长", key: "length", editable: true },
        { title: "检测设备", key: "device_no", editable: true },
      ],
      batch_piece_list: {},
      formValidate: {
        id: "",
        orderNo: "",
        batchId: "",
        count: 0,
        ids: [],
        type: 0,
      },
      all_piece: 0,
      used_count: 0,
      mayCount: 0,
      exportCount: 0,
      ruleValidate: {},
    };
  },
  watch: {
    resetFlag(resetFlag) {
      this.handleReset("formValidate");
    },
    editData(editData) {
      this.formValidate.id = editData.id;
      this.formValidate.orderNo = editData.order_no;
    },
  },
  methods: {
    addPiece() {
      if (this.formValidate.count >= this.all_piece - this.used_count) {
        return
      }
      this.formValidate.count += 1
      this.mayCount = this.all_piece - this.used_count - this.formValidate.count
    },
    cutPiece() {
      this.formValidate.count -= 1
      this.mayCount = this.all_piece - this.used_count - this.formValidate.count
      if (this.formValidate.count < 0) {
        this.formValidate.count = 0
        this.mayCount = this.all_piece - this.used_count - this.formValidate.count
      }
    },
    calPiece() {
      if (this.exportCount < 0) {
        this.formValidate.count -= this.exportCount
        if (this.formValidate.count < 0) {
          this.formValidate.count = 0
        }
      } else if (this.exportCount > 0) {
        this.formValidate.count += this.exportCount
        if (this.formValidate.count > this.all_piece - this.used_count) {
          this.formValidate.count = this.all_piece - this.used_count
        } 
      }
    },
    selectData(selection) {
      let piece_ids = [];
      for (let i = 0; i < selection.length; i++) {
        piece_ids[i] = selection[i].id;
      }
      this.batch_piece_list[this.formValidate.batchId] = piece_ids;
    },
    searchBatch(params) {
      searchBatch(params).then((res) => {
        if (res.data.code == 200) {
          this.batchList = res.data.data.records;
        }
      });
    },
    searchPiece(batchId) {
      if (!batchId) {
        return;
      }
      let params = {
        batchId: batchId,
        status: 3,
      };
      this.tableLoading = true;
      searchPiece(params)
        .then((res) => {
          if (res.data.code == 200) {
            this.tableData = res.data.data.records;
            window.setTimeout(() => {
              let length = Object.keys(
                this.$refs.tables.$refs.selection.objData
              ).length;
              if (!this.batch_piece_list[batchId]) {
                this.tableLoading = false;
                return;
              }
              for (let i = 0; i < length; i++) {
                if (
                  this.batch_piece_list[batchId].indexOf(
                    this.$refs.tables.$refs.selection.objData[i].id
                  ) != -1
                ) {
                  this.$refs.tables.$refs.selection.objData[
                    i
                  ]._isChecked = true;
                }
              }
              this.tableLoading = false;
            }, 1000);
          } else {
            this.tableData = [];
            this.tableLoading = false;
          }
        })
        .catch((err) => {
          this.tableLoading = false;
          this.$Message.error(err);
        });
    },
    initData(params) {
      this.formValidate.id = params.row.id;
      this.formValidate.orderNo = params.row.order_no;
      this.formValidate.batchId = "";
      this.formValidate.ids = [];
      this.formValidate.type = params.row.type;

      this.all_piece = params.row.expect_piece_count
      this.used_count = params.row.usedCount
      this.mayCount = this.all_piece - this.used_count

      this.batch_piece_list = {};
      this.tableData = [];
      let _params = {
        orderId: this.formValidate.id,
      };
      this.searchBatch(_params);
    },
    handleSubmit(name) {
      this.formValidate.ids = [];
      let batch_ids = Object.keys(this.batch_piece_list);
      for (let i = 0; i < batch_ids.length; i++) {
        for (let j = 0; j < this.batch_piece_list[batch_ids[i]].length; j++) {
          this.formValidate.ids.push(this.batch_piece_list[batch_ids[i]][j]);
        }
      }

      if (this.formValidate.ids.length == 0 && this.formValidate.type == 0) {
        this.$Message.error("请选择布匹");
        return
      }
      if (this.formValidate.count <= 0 && this.formValidate.type == 1) {
        this.$Message.error("出货匹数不能小于0")
        return
      }
      let data = new FormData();
      data.append("count", this.formValidate.count);
      data.append("ids", this.formValidate.ids);
      data.append("orderNo", this.formValidate.orderNo);
      addPieceShipment(data).then((res) => {
        if (res.data.code == 200) {
          this.$Message.success(res.data.msg);
          this.$emit("on-ok");
        } else {
          this.$Message.error(res.data.msg);
        }
      });
    },
    handleReset(name) {
      this.$refs[name].resetFields();
    },
  },
};
</script>
